import Spinner from 'react-bootstrap/Spinner';
import classes from './MiniLoader.module.css';
function MiniLoader() {
  return (
    <div className={classes.wrapper}>
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}

export default MiniLoader;
